import React, { useState } from 'react';
import AllBets from './components/AllBets/AllBets';
import Propositions from './components/Propositions/Propositions';
import { Button, HStack } from '@chakra-ui/react';
import Combinations from './components/Combinations/Combinations';

export default function SameGameMulti() {
  enum ETab {
    allBets = 'allBets',
    propositions = 'propositions',
    combinations = 'combinations',
  }

  const [tab, setTab] = useState<ETab>(ETab.allBets);

  return (
    <>
      <HStack gap="2" m="2">
        <Button
          colorScheme="gray"
          onClick={() => setTab(ETab.allBets)}
          isActive={tab === ETab.allBets}
          _active={{ bg: 'origin.500', color: 'white' }}
        >
          All SGMs
        </Button>
        <Button
          colorScheme="gray"
          onClick={() => setTab(ETab.propositions)}
          isActive={tab === ETab.propositions}
          _active={{ bg: 'origin.500', color: 'white' }}
        >
          Propositions
        </Button>
        <Button
          colorScheme="gray"
          onClick={() => setTab(ETab.combinations)}
          isActive={tab === ETab.combinations}
          _active={{ bg: 'origin.500', color: 'white' }}
        >
          Combinations
        </Button>
      </HStack>
      {tab === ETab.allBets && <AllBets />}
      {tab === ETab.propositions && <Propositions />}
      {tab === ETab.combinations && <Combinations />}
    </>
  );
}
